import SearchBar from "components/base/SearchBar";
import PageV2 from "components/shared/PageV2";
import { Link, useParams, useSearchParams } from "react-router-dom";
import ForecastTableView from "./FcstTableView";

const OverviewPage = () => {
  const { mode } = useParams();
  const [searchParams, setSearchParams] = useSearchParams({
    onlyFcst: true,
  });
  const params = Object.fromEntries(searchParams.entries());

  const q = params.q || "";
  const onlyFcst = params.onlyFcst !== "false";

  return (
    <PageV2
      testing
      backTo="./.."
      title={`${mode} / Sales Forecast Overview`}
      subtitle="Submitted forecasts are shown in this page."
      toolbar={
        <div className="flex items-center space-x-6">
          <Link to="categories">Forecast Categories</Link>
        </div>
      }
    >
      <div className="flex-1 overflow-auto flex flex-col space-y-4">
        <div className="flex space-x-4 items-center">
          <div className="flex-1">
            <SearchBar
              value={q}
              onChange={(q) => setSearchParams({ ...params, q })}
            />
          </div>
          <div className="flex items-center whitespace-nowrap">
            <input
              id="onlyFcst"
              type="checkbox"
              className="mr-1"
              checked={onlyFcst}
              onChange={(e) =>
                setSearchParams({
                  ...params,
                  onlyFcst: e.target.checked ? "true" : "false",
                })
              }
            />
            <label htmlFor="onlyFcst">Has Fcsted Only</label>
          </div>
        </div>
        <div className="card p-0 flex-1 overflow-auto text-xs relative">
          <ForecastTableView mode={mode} q={q} onlyFcst={onlyFcst} />
        </div>
      </div>
    </PageV2>
  );
};

export default OverviewPage;
